/**
 * 작성자 : 홍선영
 * 날짜 : 2025.11.14
 * 경로 : 자유게시판
 */

import Tab from '../../components/Tab';
import { useOutletContext, useSearchParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { IUser, pageInfoState, userState } from '../../atoms';
import { useEffect, useState } from 'react';
import { ITabObject } from 'customTypes';
import Board from './board/board';

const CBoard = () => {
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const userInfo = useRecoilValue<IUser>(userState);
  const { userMenuList } = userInfo;
  const [newTabList, setNewTabList] = useState<ITabObject[]>();
  const [searchParams] = useSearchParams();
  const tabCd = searchParams.get('tabCd');

  // URL의 tabCd 파라미터 변경 감지하여 탭 업데이트
  useEffect(() => {
    if (tabCd && tabCd !== currentTabMrCd) {
      setCurrentTabMrCd(tabCd);
    }
  }, [tabCd]);

  useEffect(() => {
    const arr: any[] = [];
    userMenuList.map((v: any) => {
      const result = tabInfo?.tabList?.find((el: ITabObject) => el.mtCd === v.mtCd && el.mdCd === v.mdCd && el.mrCd === v.mrCd);
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  const onClickTab = (mrCd: string) => {
    setCurrentTabMrCd(mrCd);
  };

  const activeTab = newTabList?.find((el: ITabObject) => el.mrCd === currentTabMrCd);
  const renderPage = () => {
    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <Board type='c' />; // 자유게시판
        default:
          return <Board type='c' />;
      }
    }
    return undefined;
  };

  return (
    <div className='contents'>
      <Tab tabList={newTabList || tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
      {renderPage()}
    </div>
  );
};

export default CBoard;
